export default Object.freeze({
  ADMIN: 1,
  SUPERVISOR: 2,
  ANALISTA: 3,
});
